import { HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiUrls } from '../../../../config/api-urls/api-urls';
import { MainService } from '../../../../provider/main.service';

@Component({
  standalone: false,
  selector: 'app-add-library',
  templateUrl: './add-library.component.html',
  styleUrls: ['./add-library.component.css']
})
export class AddLibraryComponent implements OnInit {
  form: FormGroup | any;
  imageType: any;
  file: any;
  fileUrl: any;
  myFile: any;
  constructor(private router: Router, public mainService: MainService) { }

  ngOnInit() {
    this.form = new FormGroup({
      "docName": new FormControl('', Validators.required),
    });
  }

  ValidateFileUpload(event: any) {
    this.file = event.target.files;
    this.myFile = this.file[0].name;
    if (this.file[0]) {
      this.imageType = this.file[0].type;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.fileUrl = e.target.result;
      };
      reader.readAsDataURL(this.file[0]);
    }
  }

  addLibraryApi() {
    const formData: FormData = new FormData();
    formData.append('title', this.form.value.docName);
    formData.append('document', this.file[0]);

    this.mainService.showSpinner();
    this.mainService.postApi(ApiUrls.addLibrary, formData, 3).subscribe((res) => {
      this.mainService.hideSpinner();
      if (res.responseCode == 200) {
        this.mainService.successToast(res.responseMessage);
        this.router.navigate(['library-mgt'])
      }
      else {
        this.mainService.errorToast(res.responseMessage);

      }
    }, err => {
      this.mainService.hideSpinner();
      this.mainService.errorToast(err.responseMessage);
    })
  }
}
